import React, { useEffect } from 'react'
import * as Survey from "survey-react";
import "survey-react/survey.css";
import "./css/SurveyJsComp.css"
import { HandleMarkdown } from "../../common/surveyJsHelpers";

const SurveyJsComp = ({survey, formData, isReadOnly, showNavButtons=true, handleSaveClick, onSubmit, onComplete, handleCustomValueChange}) => {

    Survey
        .JsonObject
        .metaData
        .addProperty("page", { name: "hideOnPreview:boolean", default: false });

    Survey
        .JsonObject
        .metaData
        .addProperty("panel", { name: "hideOnPreview:boolean", default: false });

    survey.data = formData;
    survey.showNavigationButtons = showNavButtons;
    
    var mylocalization = Survey.surveyLocalization.locales["en"];
    mylocalization.cleanCaption = "Remove all";
    mylocalization.completingSurvey = "Submitting Form";
    mylocalization.emptySurvey = "There are no visible questions in the form"
    survey.currentPage = survey.pages[survey.pageCount - 1];

    survey
        .onTextMarkdown
        .add((survey, options) => HandleMarkdown(survey, options));

    survey
        .onValueChanged
        .add(function (sender, options) {
            if (handleSaveClick)
                handleSaveClick(sender.data);
            else if (handleCustomValueChange)
                handleCustomValueChange(sender, options);
        });

    survey
        .onUpdatePanelCssClasses
        .add((survey, options) => {            
            let classes = options.cssClasses;
            if (survey.isDisplayMode == true && options.panel.hideOnPreview == true) {

                //  This is to hide pages we don't want to show on preview.
                classes.panel.container = "sv-hidden";
            }      
        }); 


    const completeSurvey = () => {
        return survey.completeLastPage();
    }
    const toPdf = ()=>{
        console.log('ToPDF');
    }

    useEffect(() => {
        if (onSubmit) {
            onSubmit.current = completeSurvey;
        }
    });

    if (isReadOnly) {
        survey.mode = 'display';
    }

    return (
        <Survey.Survey model={survey} onComplete={onComplete}/>
    );
};

export default SurveyJsComp;